export interface CorrectiveMaintenance {
    id?: string,
    wellStringId?: string,
    platformShortName?: string,
    platformLongName?: string,
    fieldShortName?: string,
    fieldLongName?: string,
    wellShortName?: string,
    wellLongName?: string,
    stringShortName?: string,
    stringLongName?: string,
    stringIndicatorShortName?: string,
    wellProductionStatus?: string,
    category?: string,
    source?: string,
    failureDate?: string,
    failEquipment?: string,
    problemReported?: string,
    detailDesc?: string,
    forwardActionPlan?: string,
    status?: string,
    remark?: string,
    inputBy?: string,
    inputDate?: string,
    updateBy?: string,
    updateDate?: string,
    approvedBy?: string,
    approvedDate?: string,
    rectifiedDate?: string,
    prodStatusInputDate?: string,
    wellHealtinessStatus?: string,
    failureNotificationId?: string,
    cdftRecordId?: string,
    submissionYear?: string,
    wpbId?: string
}

export enum CMStatus {
    OPEN = 'Open',
    READY = 'Ready to Review',
    REJECTED = 'Rejected',
    APPROVED = 'Approved',
    CLOSED = 'Closed'
}